import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'user-mgmt',
    loadChildren: () => import('aplx-ng-lib-user-mgmt').then(m => m.AplxNgLibUserMgmtModule)
  },
  {
    path: 'okr',
    loadChildren: () => import('aplx-ng-lib-okr').then(m => m.AplxNgLibOkrModule)
  },
  {
    path: 'employee-engagement',
    loadChildren: () => import('aplx-ng-lib-employee-engagement').then(m => m.AplxNgLibEmployeeEngagementModule)
  },
  {
    path: 'project-mgmt',
    loadChildren: () => import('aplx-ng-lib-project-mgmt').then(m => m.AplxNgLibProjectMgmtModule)
  },
  {
    path: 'accounts-project',
    loadChildren: () => import('aplx-ng-lib-accounts-project').then(m => m.AplxNgLibAccountsProjectModule)
  },
  {
    path: 'organisation-setup',
    loadChildren: () => import('aplx-ng-lib-organisation-setup').then(m => m.AplxNgLibOrganisationSetupModule)
  },
  {
    path: 'leave-mgmt',
    loadChildren: () => import('aplx-ng-lib-leave-mgmt').then(m => m.AplxNgLibLeaveMgmtModule)
  },
  {
    path: 'mis',
    loadChildren: () => import('aplx-ng-lib-mis').then(m => m.AplxNgLibMisModule)
  },
  // Add a default route
  { path: '', redirectTo: '/user-mgmt', pathMatch: 'full' },
  { path: '**', redirectTo: '/user-mgmt' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}